module.exports = __webpack_public_path__ + "img/arrowUpRight.9bf98f91.svg";